import { PolymerElement, html } from 'polymer';

/**
 * a tag for logical if
 *
 * @customElement
 * @polymer
 * @appliesMixin HIP.BehaviorElement
 */
class IfElement extends HIP.BehaviorContainer(HIP.BehaviorElement(PolymerElement)) {
  static get is() {
    return 'hi-if';
  }

  static get template() {
    return html`
      <style>
        :host([hidden]) {
          display: none !important;
        }

        :host(:not([hidden])) {
          display: initial !important;
        }
      </style>
      <slot id="items"></slot>
    `;
  }

  static get properties() {
    return {
      /**
       * - simple, manage only `hidden`
       * - comparator (default), manage the hidden status with `valueLeft` and `valueRight`
       */
      kind: {
        type: String,
        value: 'comparator'
      },
      /**
       * toggle if children are included in the DOM
       */
      hidden: {
        type: Boolean,
        observer: '__hiddenChanged',
        reflectToAttribute: true,
        notify: true
      },
      valueLeft: {
        type: Object,
        reflectToAttribute: true
      },
      /**
       * @enum
       * - == for equals
       * - != for not equals
       * - >, <, >=, <= where valueLeft is on the left of the comparator
       * - like, rightValue being inside of leftValue
       * - in, if leftValue is an array and rightValue is a value inside the array (uses ==)
       */
      comparator: {
        type: String,
        value: 'like',
        reflectToAttribute: true
      },
      valueRight: {
        type: Object,
        reflectToAttribute: true
      }
    };
  }

  static get api() {
    return ['show', 'hide'];
  }

  static get observers() {
    return ['__compareWatcher(valueLeft, valueRight, comparator, kind)'];
  }

  static get valueEvent() {
    return 'hidden-changed';
  }

  static get autoBinding() {
    return {
      signal: 'hidden-changed',
      slot: 'hidden'
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'group');
  }

  show() {
    this.hidden = false;
  }

  hide() {
    this.hidden = true;
  }

  __hiddenChanged(_hidden) {
    this.__reflectStatus(_hidden);
  }

  _onSlotChanged() {
    super._onSlotChanged();

    if (this.__mutex__) {
      return;
    }

    if (this.allChildren.length > 0) {
      this.__allChildrenSaved = this.allChildren;
    }

    this.__reflectStatus();
  }

  __reflectStatus(_hidden = this.hidden) {
    this.__mutex__ = true;

    const existingChildren = this.allChildren.length > 0;

    if ((_hidden && existingChildren) || (!_hidden && !existingChildren)) {
      (this.__allChildrenSaved || []).forEach((o) => {
        if (_hidden) {
          o.remove();
        } else {
          this.appendChild(o);
        }
      });
    }

    this.__mutex__ = false;
  }

  __compareWatcher(valueLeft, valueRight, comparator, kind) {
    if (kind === 'comparator') {
      if (HIP.kernel.runComparator(comparator, valueLeft, valueRight)) {
        this.show();
      } else {
        this.hide();
      }
    }
  }

  /**
   * @return {String}
   */
  toString() {
    return `${this.hidden}`;
  }
}

HIP.factory.element(IfElement);
